import { useState, useEffect } from 'react';
import useInterval from '../useInterval';
import styles from './css/main.module.css'
import Header from './header.js'
import Contents from './contents.js'
import '@aws-amplify/ui-react/styles.css'
import { Authenticator } from "@aws-amplify/ui-react";
import Sidebar from "./sidebar.js"
import Site from "./site.js"
import Dashboard from "./dashboard.js"
import Support from "./support.js"
import Guide from "./guide.js"
import Edit from "./edit.js"
import invoke from "../calllambda.js"
import sensorstatus from "./sensorstatus.js"

function AuthHeader() {
  return <div style={{paddingLeft:"0.5em", backgroundColor:"gray", color:"white", textAlign:"left", fontWeight:"bold", fontSize:"xx-large"}}>ログイン</div>
}

function AuthFooter() {
  return <></>
}

function Main() {
  return (
    <Authenticator hideSignUp components={{SignIn:{Header:AuthHeader,Footer:AuthFooter}}}>
      {({ signOut, user }) => (
        <MainContent signOut={signOut}/>
      )}
    </Authenticator>
  )
}

function MainContent(props) {
  const [menu, setMenu] = useState("map");
  const [sites, setSites] = useState([]);
  const [admin, setAdmin] = useState(0);
  const [points, setPoints] = useState([]);
  const [point, setPoint] = useState({});
  const [map, setMap] = useState({latitude:35.6894, longitude:139.6917, zoom:10});

  function usrinfoupdate() {
    invoke("arn:aws:lambda:ap-northeast-1:068557983663:function:userinformation").then(function (value) {
      setAdmin(value.admin);
      setSites(value.sites);
      setMap(value.map);
      sensorstatusupdate(value.sites)
    });
  }

  function sensorstatusupdate(asites, isRefresh = false) {
    if (asites.length > 0 && (!isRefresh || (isRefresh && (menu != "edit")))) {
      sensorstatus(asites).then(function (value) {
        setPoints(value);
        if (point?.name) {
          updatepoint(point?.name, value);
        }
      });
    }
  }

  useInterval(() => {
    sensorstatusupdate(sites, true)
  }, 1000 * 60);

  useEffect(() => {
    usrinfoupdate();
  }, []);

  function changemenu(value) {
    setMenu(value.menu);
    updatepoint(value.site, points);
  }

  function updatepoint(name, apoints) {
    const res = apoints.find((p) => p.name === name)
    if (res) setPoint(res)
  }

  return (
        <div>
          <div className={styles.header}><Header signout={props.signOut} /></div>
          <div className={styles.sidebar1}><Sidebar sites={sites} menuselect={changemenu} admin={admin} /></div>
          <div className={styles.sidebar2}><Sidebar sites={sites} menuselect={changemenu} admin={admin} small /></div>
          <div className={styles.content}>
            {menu === "map" && <Contents points={points} setsite={changemenu} map={map}/>}
            {menu === "dashboard" && <Dashboard points={points} setsite={changemenu} />}
            {menu === "site" && <Site point={point} />}
            {menu === "guide" && <Guide />}
            {menu === "support" && <Support />}
            {menu === "edit" && <Edit point={point} update={usrinfoupdate} admin={admin} />}
          </div>
        </div>
  )
}

export default Main;